import axios from "@/plugins/axios";
import { ActionTree } from "vuex";
import { RootState } from "../types";
import { AnalyseState } from "./types";
import { Complement, RecuManager } from "@/shared/recusManager";

export const actions: ActionTree<AnalyseState, RootState> = {
  async getExports({ state }, dateFiscale: string) {
    const url = "exports/status?dateFiscale=" + dateFiscale;
    return axios.get(url).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error.data);
      }
    );
  },
  async getCoffre({ state }, dateFiscale: string) {
    const url = "coffre?dateFiscale=" + dateFiscale;
    return axios.get(url).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error.data);
      }
    );
  },
  async getRecusManagers({ state }, dateFiscale: string) {
    const url =
      "bo/documentsManager/readRecusManager?dateFiscale=" + dateFiscale;
    return axios.get(url).then(
      (response: any) => {
        // console.log(response.data.response);
        return response.data.response;
      },
      (error) => {
        return Promise.reject(error.data);
      }
    );
  },
  async getOneRecusManagers({ state }, documentId: string) {
    const url = "bo/documentsManager/readDocument?documentId=" + documentId;
    return axios.get(url).then(
      (response: any) => {
        // console.log(response.data);
        return response.data.response;
      },
      (error) => {
        return Promise.reject(error.data);
      }
    );
  },
  async createOneRecusManagers({ state }, recu: RecuManager) {
    const cmpl = recu.complements;
    const url = `bo/documentsManager/createDocument?codeVendeur=${recu.numVendeur}&codeManager=${recu.numVendeur}&nomVendeur=${recu.libVendeur}&nomManager=${recu.libVendeur}`;
    return axios.post(url, cmpl).then(
      (response: any) => {
        // console.log(response.data.response);
        return response.data.response;
      },
      (error) => {
        return Promise.reject(error.data);
      }
    );
  },
  async updateOneRecusManagers({ state }, recu: RecuManager) {
    const cmpl = recu.complements;
    const url = `bo/documentsManager/updateDocument?codeVendeur=${recu.numVendeur}&codeManager=${recu.numVendeur}&nomVendeur=${recu.libVendeur}&nomManager=${recu.libVendeur}&documentId=${recu.id}`;
    return axios.post(url, cmpl).then(
      (response: any) => {
        // console.log(response.data.response);
        return response.data.response;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  },
  async getRecusCaisses({ state }, criteres: any) {
    // const cmpl = recu.complements;
    const url = `coffre?ACTION=${criteres.action}&restaurantId=${criteres.site}&dateDebut=${criteres.start}&dateFin=${criteres.end}`;
    return axios.get(url).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  },
  async getOneRecu({ state }, id: string) {
    const url = `coffre?ACTION=getRecu&pdf=true&id=${id}`;
    return axios.get(url, { responseType: "arraybuffer" }).then(
      (response) => {
        return response;
      },
      (error) => {
        return Promise.reject(error.data);
      }
    );
  },
  async getRepartitions({ state }, criteres: any) {
    // const cmpl = recu.complements;
    const url = `bo/getRepartition?typeRepartition=${criteres.typeRepartition}&statut=${criteres.type}&site=${criteres.site}&dateDebut=${criteres.start}&dateFin=${criteres.end}`;
    return axios.get(url).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error.data);
      }
    );
  },
  async getRecusCaissesCentral({ state }, criteres: any) {
    const url = `fluxfin/declare_et_en_attente_de_signatures?dateDebut=${criteres.start}&dateFin=${criteres.end}&id=${criteres.userid}`;
    return axios.get(url).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error.data);
      }
    );
  },
  async contreSigneDoc({ state }, signatureData) {
    // console.log(signatureData);
    const comm = encodeURI(signatureData.commentaire);
    const url = `fluxfin/contre_signe?restaurantId=${signatureData.restaurantId}&id=${signatureData.docId}&datefiscale=${signatureData.date}&managerName=${signatureData.managerName}&managerCode=${signatureData.managerCode}&commentaire=${comm}`;
    return axios.post(url).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error.data);
      }
    );
  },
  async relanceMail({ state }, recu) {
    const url = `bo/home/envoieMail?idRecu=${recu.id}&role=${recu.role}&utilisateur=${recu.user}&site=${recu.site}`;
    return axios.get(url).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error.data);
      }
    );
  },
  async relanceMailManquant({ state }, recu) {
    const url = `bo/home/envoieMailManquant?role=${recu.role}&id=${recu.userId}&site=${recu.site}&datefiscale=${recu.datefiscale}`;
    return axios.get(url).then(
      (response: any) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error.data);
      }
    );
  },
};
